import React from 'react';
import { Monitor, Zap, Droplets, Droplet, Building, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { mockData } from '../data/mock';

const iconMap = {
  Monitor,
  Zap,
  Droplets,
  Droplet,
  Building
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-br from-white via-[#00B050]/5 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-6xl font-bold text-slate-900 mb-4">
            Our <span className="bg-gradient-to-r from-[#003366] via-[#339933] to-[#003366] bg-clip-text text-transparent">Services</span>
          </h2>
          <p className="text-lg text-slate-600">
            Comprehensive solutions tailored to meet the unique needs of Timor-Leste's development
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {mockData.services.map((service, index) => {
            const Icon = iconMap[service.icon];
            const isEven = index % 2 === 0;
            return (
              <Card
                key={service.id}
                className="border-0 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 overflow-hidden group bg-white"
              >
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4 mb-6">
                    <div 
                      className={`flex-shrink-0 w-20 h-20 rounded-2xl flex items-center justify-center shadow-xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}
                      style={{ background: isEven ? 'linear-gradient(135deg, #1E4E9E, #00B050)' : 'linear-gradient(135deg, #00B050, #1E4E9E)' }}
                    >
                      <Icon className="w-10 h-10 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-[#003366] transition-colors">
                        {service.title}
                      </h3>
                    </div>
                  </div>

                  <p className="text-slate-600 mb-6 leading-relaxed">{service.description}</p>

                  {/* Features List */}
                  <div className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-3">
                        <div className="flex-shrink-0 w-2 h-2 rounded-full bg-gradient-to-r from-[#003366] to-[#339933]"></div>
                        <span className="text-sm text-slate-700">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <Button
                    variant="ghost"
                    className="text-[#003366] hover:text-[#74C65A] p-0 h-auto font-semibold group/btn"
                  >
                    Learn More
                    <ArrowRight className="ml-2 w-4 h-4 transform group-hover/btn:translate-x-2 transition-transform" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};